import { get } from "lodash";
import * as Yup from "yup";

export const profileValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  // phone: Yup.string()
  //   .min(10, "Please enter a valid 10 digits Phone Number")
  //   .max(10, "Please enter a valid 10 digits Phone Number")
  //   .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number")
  //   .notRequired(),
});

/* SubTags Schema Start */
export const createSubTagsSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("SubTag Name is required")
        .max(
          100,
          "Please enter your SubTag Name with a maximum of 100 characters",
        )
        .trim("SubTag Name cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("SubTag Name is required")
        .max(
          100,
          "Please enter your SubTag Name with a maximum of 100 characters",
        )
        .trim("SubTag Name cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const LoginFormSchema = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password field must contain a minimum of 8 characters")
    .max(16, "Please enter a maximum of 16 characters") // Password field must be less than 16 characters.
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
    ),
});

export const otpFormSchema = Yup.object().shape({
  username: Yup.string()
    .matches(/^\S*$/, "Username must not contain spaces")
    .required("Username is required"),
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must contain exact 6 digits")
    .required("OTP is required"),
  //mobile: Yup.string()
  //  .required('Mobile number is required')
});

export const sendOtpFormSchema = (isFromOtp: boolean) => {
  if (isFromOtp) {
    return Yup.object({
      phone: Yup.string()
        .required("Phone Number is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      otp: Yup.string()
        .required("OTP is required")
        .min(6, "Please enter a valid 6 digit OTP")
        .matches(/^\d{6}$/, "OTP must contain exact 6 digits"),
    });
  } else {
    return Yup.object({
      phone: Yup.string()
        .required("Phone Number is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      otp: Yup.string().notRequired(),
    });
  }
};

export const NewPasswordFormSchema = Yup.object().shape({
  password: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  passwordConfirmation: Yup.string()
    .oneOf(
      [Yup.ref("password"), undefined],
      "New Password and Confirm Password does not match",
    )
    .required("Please enter Confirm Password"),
});

export const ChangePasswordFormSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required("Please enter Current Password")
    .min(8, "Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Current Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  newPassword: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters") //New Password field must be less then 16 characters.
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "New Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  confirmPassword: Yup.string()
    .required("Please enter your Confirm Password.")
    .oneOf(
      [Yup.ref("newPassword")],
      "New Password and Confirm Password does not match",
    ),
});

export const ResetPasswordFormSchema = Yup.object().shape({
  newpassword: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "New Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("newpassword"), undefined],
      "New Password and Confirm Password does not match",
    )
    .required("Please enter Confirm Password"),
});

//export const otpSchema = Yup.string().length(1, 'OTP must be exactly 1 character').matches(/^[0-9]+$/, 'OTP must only contain numbers');
export const otpSchema = Yup.string()
  .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
  .required("OTP is required");

export const createGamesFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      full_name: Yup.string()
        .required("Full name is required")
        .max(30, "Please enter your Full name with a maximum of 30 characters")
        .trim("The Full name cannot include leading and trailing spaces")
        .strict(true),
      twitch_id: Yup.string().required("Twitch id is required"),
      pandascore_id: Yup.string().required("Pandascore id is required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      full_name: Yup.string()
        .required("Full name is required")
        .max(30, "Please enter your Full name with a maximum of 30 characters")
        .trim("The Full name cannot include leading and trailing spaces")
        .strict(true),
      twitch_id: Yup.string().required("Twitch id is required"),
      pandascore_id: Yup.string().required("Pandascore id is required"),
    });
  }
};

export const importCsvFormSchema = Yup.object().shape({
  file: Yup.string().notRequired(),
});

export const createAdvertiseFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const createPagesFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      // description: Yup.string().required("Full name is required").strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      // description: Yup.string().required("Full name is required").strict(true),
    });
  }
};

export const createEmployerFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      firstName: Yup.string()
        .required("First name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      lastName: Yup.string()
        .required("Last name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .required("Email is required")
        .matches(/^\S*$/, "Email must not contain spaces"),
      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(
          30,
          "Please enter your Comapny Name with a maximum of 30 characters",
        )
        .trim("Company Name cannot include leading and trailing spaces")
        .strict(true),
      companySize: Yup.string()
        .required("Company Size is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyFounded: Yup.string()
        .required("Company Founded is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyUrl: Yup.string()
        .required("Company Url is required")
        // .matches(
        //   /^(http|https):\/\/[^ "]+$/,
        //   "Company URL must be a valid URL and start with http or https",
        // )
        .matches(/^(https?)/, "Company URL must start with http or https")
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyDiversity: Yup.string()
        .required("Company Diversity is required")
        .trim(
          "The Company Diversity cannot include leading and trailing spaces",
        )
        .strict(true),
      companyScore: Yup.number()
        .transform((value, originalValue) => {
          // If the original value is an empty string, transform it to undefined
          return originalValue.trim() === "" ? undefined : value;
        })
        .required("Company Score is required")
        .max(5, "Company Score must not be greater than 5"),
      motivator: Yup.array()
        .required("Motivator is required")
        .min(1, "Please select at least one motivator"),
      companyInfo: Yup.string()
        .required("Company Info is required")
        .trim("The Company Info cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      firstName: Yup.string()
        .required("First name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      lastName: Yup.string()
        .required("Last name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .required("Email is required")
        .matches(/^\S*$/, "Email must not contain spaces"),
      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password field must contain a minimum of 8 characters")
        .max(16, "Please enter a maximum of 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      confirmpassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf(
          [Yup.ref("password")],
          "Confirm Passwords and Password must match",
        )
        .min(8, "Password field must contain a minimum of 8 characters")
        .max(16, "Please enter a maximum of 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(
          30,
          "Please enter your Comapny Name with a maximum of 30 characters",
        )
        .trim("Company Name cannot include leading and trailing spaces")
        .strict(true),
      companySize: Yup.string()
        .required("Company Size is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyFounded: Yup.string()
        .required("Company Founded is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyUrl: Yup.string()
        .required("Company Url is required")
        // .matches(
        //   /^(http|https):\/\/[^ "]+$/,
        //   "Company URL must be a valid URL and start with http or https",
        // )
        .matches(/^(https?)/, "Company URL must start with http or https")
        .trim("Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyDiversity: Yup.string()
        .required("Company Diversity is required")
        .trim(
          "The Company Diversity cannot include leading and trailing spaces",
        )
        .strict(true),
      companyScore: Yup.number()
        .transform((value, originalValue) => {
          // If the original value is an empty string, transform it to undefined
          return originalValue.trim() === "" ? undefined : value;
        })
        .required("Company Score is required")
        .max(5, "Company Score must not be greater than 5"),

      motivator: Yup.array()
        .required("Motivator is required")
        .min(1, "Please select At least one motivator"),
      companyInfo: Yup.string()
        .required("Company Info is required")
        .trim("The Company Info cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const createContactFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      description: Yup.string()
        .required("Description is required")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      description: Yup.string()
        .required("Description is required")
        .strict(true),
    });
  }
};

export const createUserFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      first_name: Yup.string()
        .required("Full Name is required")
        .max(50, "Please enter your Full Name with a maximum of 50 characters")
        .trim("The Full Name cannot include leading and trailing spaces")
        .strict(true),
      last_name: Yup.string().required("Last Name is required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
      first_name: Yup.string()
        .required("Full Name is required")
        .max(50, "Please enter your Full Name with a maximum of 50 characters")
        .trim("The Full Name cannot include leading and trailing spaces")
        .strict(true),
      last_name: Yup.string().required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      // password: Yup.string().required("Password is required"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password field contain minimum 8 characters")
        .max(16, "Please enter maximum 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      mobile_no: Yup.string().required("Mobile No is required"),
    });
  }
};

/* Developer Schema Start */
export const createDevelopersSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      developerName: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Developer Name is required")
            .max(100, "Please enter your Name with a maximum of 100 characters")
            .trim("Developer Name cannot include leading and trailing spaces")
            .strict(true),
        }),
      ),
      // adminAccess: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string()
      //       .required("Person Name is required")
      //       .max(100, "Please enter your Name with a maximum of 100 characters")
      //       .trim("Name cannot include leading and trailing spaces")
      //       .strict(true),
      //     mobileNo: Yup.string()
      //       .required("Person Mobile Number is required")
      //       .min(10, "Please enter a valid 10 digits Phone Number")
      //       .max(10, "Please enter a valid 10 digits Phone Number")
      //       .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      //     // other member fields
      //   }),
      // ),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(100, "Please enter Company Name with a maximum of 50 characters")
        .trim("Company Name cannot include leading and trailing spaces")
        .strict(true),
      constitution: Yup.string().required("Constitution is required"),
      officeAddress: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      // logo: Yup.string().required("Developer Logo is required").strict(true),
      promoterName: Yup.string()
        .required("Promoter Name is required")
        .max(50, "Please enter Promoter Name with a maximum of 50 characters")
        .trim("Promoter Name cannot include leading and trailing spaces")
        .strict(true),
      promoterMobileNo: Yup.string()
        .required("Phone Number is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      contactPersonName: Yup.string()
        .required("Contact Person Name is required")
        .max(
          50,
          "Please enter Contact Person Name with a maximum of 50 characters",
        )
        .trim("Contact Person Name cannot include leading and trailing spaces")
        .strict(true),
      // contactPersonMobileNo: Yup.string()
      //   .required("Phone Number is required")
      //   .min(10, "Please enter a valid 10 digits Phone Number")
      //   .max(10, "Please enter a valid 10 digits Phone Number")
      //   .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      email: Yup.string()
        .nullable()
        .optional()
        .email("Please enter a valid email")
        .matches(/^\S*$/, "Email must not contain spaces"),
      // website: Yup.string()
      //   .required("Website is required")
      // .matches(
      //   /^(http|https):\/\/[^ "]+$/,
      //   "Company URL must be a valid URL and start with http or https",
      // )
      // .matches(/^(https?)/, "Website must start with http or https")
      // .strict(true),
    });
  } else {
    return Yup.object().shape({
      developerName: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Developer Name is required")
            .max(100, "Please enter your Name with a maximum of 100 characters")
            .trim("Developer Name cannot include leading and trailing spaces")
            .strict(true),
        }),
      ),
      // adminAccess: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string()
      //       .max(100, "Please enter your Name with a maximum of 100 characters")
      //       .trim("Name cannot include leading and trailing spaces")
      //       .strict(true),
      //     mobileNo: Yup.string()
      //       .min(10, "Please enter a valid 10 digits Phone Number")
      //       .max(10, "Please enter a valid 10 digits Phone Number")
      //       .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      //   }),
      //   // other member fields
      // ),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(50, "Please enter Company Name with a maximum of 50 characters")
        .trim("Company Name cannot include leading and trailing spaces")
        .strict(true),
      constitution: Yup.string().required("Constitution is required"),
      officeAddress: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      // logo: Yup.string().required("Developer Logo is required").strict(true),
      promoterName: Yup.string()
        .required("Promoter Name is required")
        .max(50, "Please enter Promoter Name with a maximum of 50 characters")
        .trim("Promoter Name cannot include leading and trailing spaces")
        .strict(true),

      promoterMobileNo: Yup.string()
        .required("Phone Number is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      contactPersonName: Yup.string()
        .required("Contact Person Name is required")
        .max(
          50,
          "Please enter Contact Person Name with a maximum of 50 characters",
        )
        .trim("Contact Person Name cannot include leading and trailing spaces")
        .strict(true),
      contactPersonMobileNo: Yup.string()
        .required("Phone Number is required")
        .min(10, "Please enter a valid 10 digits Phone Number")
        .max(10, "Please enter a valid 10 digits Phone Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
      email: Yup.string()
        .nullable()
        .optional()
        .email("Please enter a valid email")
        .matches(/^\S*$/, "Email must not contain spaces"),
      // website: Yup.string()
      //   .required("Website is required")
      // .matches(
      //   /^(http|https):\/\/[^ "]+$/,
      //   "Company URL must be a valid URL and start with http or https",
      // )
      // .matches(/^(https?)/, "Web Site must start with http or https")
      // .strict(true),
    });
  }
};
/* Developer Schema End */

/* Document Schema Start */
export const createDocumentSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      fieldName: Yup.string().required("Field Name is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Name is required")
            .max(100, "Please enter Name with a maximum of 100 characters"),
          size: Yup.number()
            .required("Size Value is required")
            .typeError("Size must be a number")
            .max(100, "Please enter Size with a maximum of 100 characters"),
          position: Yup.number()
            .required("Position Value is required")
            .typeError("Position must be a number"),
        }),
      ),
    });
  } else {
    return Yup.object().shape({
      fieldName: Yup.string().required("Field Name is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Name is required")
            .max(100, "Please enter Name with a maximum of 100 characters"),
          size: Yup.number()
            .required("Size Value is required")
            .typeError("Size must be a number")
            .max(100, "Please enter Size with a maximum of 100 characters"),

          position: Yup.number()
            .required("Position Value is required")
            .typeError("Position must be a number"),
        }),
      ),
    });
  }
};
/* Document Schema End */

/* Dropdown Schema Start */
export const createDropdownSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      // settingCategory: Yup.string().required("Name is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Name is required")
            .max(100, "Please enter Name with a maximum of 100 characters"),
          position: Yup.number()
            .required("Position Value is required")
            .typeError("Position must be a number"),
        }),
      ),
    });
  } else {
    return Yup.object().shape({
      settingCategory: Yup.string().required("Name is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Name is required")
            .max(100, "Please enter  Name with a maximum of 100 characters"),
          position: Yup.number()
            .required("Position Value is required")
            .typeError("Position must be a number"),
        }),
      ),
    });
  }
};
/* Dropdown Schema End */

/* Setting Master Schema Start*/
export const createSettingMasterDocumentSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Setting Master Name is required")
        .max(
          100,
          "Please enter your Setting Master Name with a maximum of 100 characters",
        ),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Setting Master Name is required")
        .max(
          100,
          "Please enter your Setting Master Name with a maximum of 100 characters",
        ),
    });
  }
};
/* Setting Master Schema End*/

/* Setting Category Schema Start */
export const createSettingCategorySchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(100, "Please enter Field with a maximum of 100 characters"),

      settingSlug: Yup.string().required("Category Type is required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(100, "Please enter Field with a maximum of 100 characters"),
      settingSlug: Yup.string().required("Category Type is required"),
    });
  }
};
/* Setting Category Schema End */

/* User Role Schema Start */
export const createUserRoleSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("User Role is required")
        .max(
          100,
          "Please enter your User Role with a maximum of 100 characters",
        ),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("User Role is required")
        .max(
          100,
          "Please enter your User Role with a maximum of 100 characters",
        ),
    });
  }
};
/* User Role Schema End */

/* Create Project Site Schema Start */

/* const blockNoUniqueTest = (blocks: any) => {
  const blockNames = blocks.map((block: any) =>
    block.blockNo.trim().toLowerCase(),
  );
  const hasDuplicates = blockNames.some(
    (name: any, index: any) => blockNames.indexOf(name) !== index,
  );
  console.log("hasDuplicates", hasDuplicates);
  return hasDuplicates;
}; */

export const createProjectSiteSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      block: Yup.array().of(
        Yup.object().shape({
          blockNo: Yup.string()
            //.required("Block Name is required")
            .max(
              100,
              "Please enter Block Name with a maximum of 100 characters",
            )
            .trim("Block Name cannot include leading and trailing spaces")
            .notRequired(),
          units: Yup.array().of(
            Yup.object().shape({
              unit: Yup.string().notRequired(),
              type: Yup.string().notRequired(),
            }),
          ),
        }),
      ),
      projectName: Yup.string()
        .required("Project Name is required")
        .max(100, "Please enter Project Name with a maximum of 100 characters")
        .trim("Project Name cannot include leading and trailing spaces")
        .strict(true),
      state: Yup.string().required("State is required"),
      address: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      city: Yup.string().required("City is required"),
      noOfTowers: Yup.number()
        .typeError("No.of Block/Towers is required")
        .min(1, "Value must be greater than 0")
        .required("No.of Block/Towers is required"),
      pinCode: Yup.string()
        .transform((value) => (value ? value.toString() : ""))
        .required("Pincode is required")
        .trim("Pincode cannot include leading and trailing spaces")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(6, "Pincode must be 6 digits"),
      towers: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(0, "Must be exactly 0 digits")
        .max(2, "Must be exactly 2 digits")
        .strict(true),
      landmark: Yup.string()
        .required("Landmark is required")
        .max(100, "Please select Landmark")
        .strict(true),
      projectType: Yup.string()
        .required("Project Type is required")
        .max(100, "Please select Project Type")
        .strict(true),
      reraRegistrationNo: Yup.string()
        .required("RERA Registration Number is required")
        .max(150, "Please enter a valid 150 digits RERA Registration Number")
        .strict(true),
      reraRegistrationDate: Yup.string().required(
        "RERA Registration Date is required",
      ),
      rajaChitthiDate: Yup.string().required("Rajachitthi Date is required"),
      endDate: Yup.string().required("Project End Date is required"),
    });
  } else {
    return Yup.object().shape({
      block: Yup.array().of(
        Yup.object().shape({
          blockNo: Yup.string()
            .test(
              "blockNo",
              "Block names must be unique",
              function (value: any, context: any) {
                //console.log("## >>> value:", value);
                //console.log("## >>> context:", context);
                const trgArr = get(context, "from[1].value.block", []);
                const isUnique =
                  trgArr.filter(
                    (item: any) =>
                      item?.blockNo?.trim().toLowerCase() ===
                      value.trim().toLowerCase(),
                  ).length === 1;
                return isUnique;
              },
            )
            .required("Block name is required")
            .max(
              100,
              "Please enter Block name with a maximum of 100 characters",
            )
            .trim("Block Name cannot include leading and trailing spaces"),
          //.strict(true),
          units: Yup.array().of(
            Yup.object().shape({
              unit: Yup.string()
                // .matches(/^[1-9]\d*$/, "Must be greater than 0") // Ensure valid format
                .test(
                  "greater-than-zero",
                  "Value must be greater than 0",
                  function (value: any) {
                    const parsedValue = parseInt(value, 10) || 0; // Parse the value to an integer

                    let unitList: any = this.from;
                    unitList = unitList[1].value.units;
                    const residentialType = unitList.find(
                      (ele: any) => ele.type === "residential",
                    );
                    const commercialType = unitList.find(
                      (ele: any) => ele.type === "commercial",
                    );

                    if (unitList.length === 2) {
                      if (this.parent.type === residentialType.type) {
                        if (
                          parsedValue <= 0 &&
                          !parseInt(commercialType.unit, 10)
                        ) {
                          return this.createError({
                            path: this.path,
                            message: "Value must be greater than 0",
                          });
                        } else {
                          return true;
                        }
                      }

                      if (this.parent.type === commercialType.type) {
                        if (
                          parsedValue <= 0 &&
                          !parseInt(residentialType.unit, 10)
                        ) {
                          return this.createError({
                            path: this.path,
                            message: "Value must be greater than 0",
                          });
                        } else {
                          return true;
                        }
                      }
                    } else {
                      if (parsedValue <= 0) {
                        return this.createError({
                          path: this.path,
                          message: "Value must be greater than 0",
                        });
                      }
                    }

                    return true;
                  },
                ),
              type: Yup.string().notRequired(),
            }),
          ),
        }),
      ),
      projectName: Yup.string()
        .required("Project Name is required")
        .max(100, "Please enter Project Name with a maximum of 100 characters")
        .trim("Project Name cannot include leading and trailing spaces")
        .strict(true),
      state: Yup.string().required("State is required"),
      address: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      city: Yup.string().required("City is required"),
      noOfTowers: Yup.number()
        .typeError("No.of Block/Towers is required")
        .min(1, "Value must be greater than 0")
        .required("No.of Block/Towers is required"),
      pinCode: Yup.string()
        .transform((value) => (value ? value.toString() : ""))
        .required("Pincode is required")
        .trim("Pincode cannot include leading and trailing spaces")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(6, "Pincode must be 6 digits"),
      towers: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(0, "Must be exactly 0 digits")
        .max(2, "Must be exactly 2 digits")
        .strict(true),
      landmark: Yup.string()
        .required("Landmark is required")
        .max(100, "Please select Landmark")
        .strict(true),
      projectType: Yup.string()
        .required("Project Type is required")
        .max(100, "Please select Project Type")
        .strict(true),
      reraRegistrationNo: Yup.string()
        .required("RERA Registration Number is required")
        .max(150, "Please enter a valid 150 digits RERA Registration Number")
        .strict(true),
      reraRegistrationDate: Yup.string().required(
        "RERA Registration Date is required",
      ),
      rajaChitthiDate: Yup.string().required("Rajachitthi Date is required"),
      endDate: Yup.string().required("Project End Date is required"),
    });
  }
};

/* Create Project Site Schema End */

/* Project Schema Start */
export const createProjectSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      blockDetails: Yup.array().of(
        Yup.object().shape({
          blockNo: Yup.string()
            .required("Block Name is required")
            .max(
              100,
              "Please enter Block Name with a maximum of 100 characters",
            )
            .trim("Block Name cannot include leading and trailing spaces")
            .strict(true),
          units: Yup.array().of(
            Yup.object().shape({
              unit: Yup.string()
                .required("Units is required")
                // .matches(/^[1-9]+$/, "Must be greater than 1")
                .min(1, "Minimum 1 digit")
                .max(5, "Maximum 5 digits"),
              type: Yup.string().notRequired(),
            }),
          ),
        }),
      ),
      projectName: Yup.string()
        .required("Project Name is required")
        .max(100, "Please enter Project Name with a maximum of 100 characters")
        .trim("Project Name cannot include leading and trailing spaces")
        .strict(true),
      state: Yup.string().required("State is required"),
      address: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      city: Yup.string().required("City is required"),
      noOfTowers: Yup.number()
        .typeError("No.of Block/Towers is required")
        .required("No.of Block/Towers is required"),
      pinCode: Yup.string()
        .transform((value) => (value ? value.toString() : ""))
        .required("Pincode is required")
        .trim("Pincode cannot include leading and trailing spaces")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(6, "Pincode must be 6 digits"),
      towers: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(0, "Must be exactly 0 digits")
        .max(2, "Must be exactly 2 digits")
        .strict(true),
      landmark: Yup.string()
        .required("Landmark is required")
        .max(100, "Please select Landmark")
        .strict(true),
      projectType: Yup.string()
        .required("Project Type is required")
        .max(100, "Please select Project Type")
        .strict(true),
      reraRegistrationNo: Yup.string()
        .required("RERA Registration Number is required")
        .max(150, "Please enter a valid 150 digits RERA Registration Number")
        .strict(true),
      reraRegistrationDate: Yup.string().required(
        "RERA Registration Date is required",
      ),
      rajaChitthiDate: Yup.string().required("Rajachitthi Date is required"),
      endDate: Yup.string().required("Project End Date is required"),
    });
  } else {
    return Yup.object().shape({
      blockDetails: Yup.array().of(
        Yup.object().shape({
          blockNo: Yup.string()
            .required("Block name is required")
            .max(
              100,
              "Please enter Block name with a maximum of 100 characters",
            )
            .trim("Block Name cannot include leading and trailing spaces")
            .strict(true),
          units: Yup.array().of(
            Yup.object().shape({
              unit: Yup.string()
                .required("Units is required")
                // .matches(/^[1-9]+$/, "Must be greater than 1")
                .min(1, "Minimum 1 digit")
                .max(5, "Maximum 5 digits"),
              type: Yup.string().notRequired(),
            }),
          ),
        }),
      ),
      projectName: Yup.string()
        .required("Project Name is required")
        .max(100, "Please enter Project Name with a maximum of 100 characters")
        .trim("Project Name cannot include leading and trailing spaces")
        .strict(true),
      state: Yup.string().required("State is required"),
      address: Yup.string()
        .required("Address is required")
        .max(100, "Please enter Address with a maximum of 100 characters")
        .trim("Address cannot include leading and trailing spaces")
        .strict(true),
      city: Yup.string().required("City is required"),
      noOfTowers: Yup.number()
        .typeError("No.of Block/Towers is required")
        .required("No.of Block/Towers is required"),
      pinCode: Yup.string()
        .transform((value) => (value ? value.toString() : ""))
        .required("Pincode is required")
        .trim("Pincode cannot include leading and trailing spaces")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(6, "Pincode must be 6 digits"),
      towers: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(0, "Must be exactly 0 digits")
        .max(2, "Must be exactly 2 digits")
        .strict(true),
      landmark: Yup.string()
        .required("Landmark is required")
        .max(100, "Please select Landmark")
        .strict(true),
      projectType: Yup.string()
        .required("Project Type is required")
        .max(100, "Please select Project Type")
        .strict(true),
      reraRegistrationNo: Yup.string()
        .required("RERA Registration Number is required")
        .max(150, "Please enter a valid 150 digits RERA Registration Number")
        .strict(true),
      reraRegistrationDate: Yup.string().required(
        "RERA Registration Date is required",
      ),
      rajaChitthiDate: Yup.string().required("Rajachitthi Date is required"),
      endDate: Yup.string().required("Project End Date is required"),
    });
  }
};

/* Project Schema End */

/* Contact Page Schema Start */
export const ContactUsFormSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(/^[A-Za-z0-9\s]+$/, "Name cannot contain special characters")
    .max(30, "Please enter your Name with a maximum of 30 characters")
    .trim()
    .strict(),
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is required"),
  description: Yup.string()
    .required("Query Message is required")
    .trim()
    .strict(),
});
/* Contact Page Schema End */

/* memberName: [{ name: "" }],
developerName: get(developerByIdData, "developerName[0].name", ""),
projectSite: get(developerByIdData, "projectSites[0].projectName", ""),
unit: "",
email: "",
mobileNo: "",
kycDocType: "",
kycDocNumber: "", */

/* Member Schema Start */
export const createMemberSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      memberName: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Member Name is required")
            .max(100, "Please enter your Name with a maximum of 100 characters")
            .trim("Name cannot include leading and trailing spaces")
            .strict(true),
          // other member fields
        }),
      ),
      // developerName: Yup.string()
      //   .required("Developer name is required")
      //   .max(
      //     30,
      //     "Please enter your Developer Name with a maximum of 30 characters",
      //   )
      //   .trim("Name cannot include leading and trailing spaces")
      //   .strict(true),
      projectSite: Yup.string()
        .required("Project Site is required")
        .max(
          50,
          "Please enter your projectSite with a maximum of 50 characters",
        )
        .trim("The projectSite cannot include leading and trailing spaces")
        .strict(true),
      unit: Yup.string()
        .required("Unit is required")
        .max(30, "Please enter your Unit with a maximum of 30 characters")
        .trim("The Unit cannot include leading and trailing spaces")
        .strict(true),
      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Mobile Number")
        .max(10, "Please enter a valid 10 digits Mobile Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Mobile Number"),
      kycDocument: Yup.string().required("KYC Document is required"),
      documentNo: Yup.string().required("KYC Document Number is required"),
      /* carpetArea: Yup.string()
        .required("Carpet Area is required")
        .max(
          30,
          "Please enter your Carpet Area with a maximum of 30 characters",
        )
        .trim("The Carpet Area cannot include leading and trailing spaces")
        .strict(true),
      terraceArea: Yup.string()
        .required("Terrace Area is required")
        .max(
          30,
          "Please enter your Terrace Area with a maximum of 30 characters",
        )
        .trim("The Terrace Area cannot include leading and trailing spaces")
        .strict(true),
      balconyArea: Yup.string()
        .required("Balcony Area is required")
        .max(30, "Please enter a Balcony Area with 30 characters")
        .trim("Balcony Area cannot include leading and trailing spaces")
        .strict(true), */
    });
  } else {
    return Yup.object().shape({
      memberName: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .required("Member Name is required")
            .max(100, "Please enter your Name with a maximum of 100 characters")
            .trim("Name cannot include leading and trailing spaces")
            .strict(true),
          // other member fields
        }),
      ),
      // developerName: Yup.string()
      //   .required("Developer name is required")
      //   .max(
      //     30,
      //     "Please enter your Developer Name with a maximum of 30 characters",
      //   )
      //   .trim("Name cannot include leading and trailing spaces")
      //   .strict(true),
      projectSite: Yup.string()
        .required("Project Site is required")
        .max(
          50,
          "Please enter your projectSite with a maximum of 50 characters",
        )
        .trim("The projectSite cannot include leading and trailing spaces")
        .strict(true),
      unit: Yup.string()
        .required("Unit is required")
        .max(30, "Please enter your Unit with a maximum of 30 characters")
        .trim("The Unit cannot include leading and trailing spaces")
        .strict(true),

      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Mobile Number")
        .max(10, "Please enter a valid 10 digits Mobile Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Mobile Number"),
      kycDocument: Yup.string().required("KYC Document is required"),
      documentNo: Yup.string().required("KYC Document Number is required"),
    });
  }
};
/* Member Schema End */

/* Unit Schema Start */
export const unitSchema = () => {
  return Yup.object().shape({
    blockNo: Yup.string()
      .required("Block No is required")
      .max(30, "Please enter your Block No with a maximum of 30 characters")
      .trim("The Block No cannot include leading and trailing spaces")
      .strict(true),
    noOfUnit: Yup.string()
      .required("noOfUnit is required")
      .max(30, "Please enter your noOfUnit with a maximum of 30 characters")
      .trim("The noOfUnit cannot include leading and trailing spaces")
      .strict(true),
  });
};
/* Unit Schema End */

/* Landmark Schema Start */
export const createLandmarkSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("Name cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};
/* Landmark Schema End */

/* Add Unit Schema Start*/
export const addUnitsScheme = Yup.object().shape({
  blockNo: Yup.string().required("Block No is required"),
  unitType: Yup.string().required("Unit Type is required"),
  noOfUnits: Yup.number()
    .typeError("Please enter a valid number")
    .moreThan(0, "No. of Units should be greater than 0")
    .max(99999, "Please enter a valid 5-digit Units Number")
    .required("Please enter a number of Units"),
});

/* Add Unit Schema End*/

/* Project Site Schema Start */
export const projectSiteSchema = Yup.object().shape({
  groupName: Yup.string().required("Group Name is required"),
  cityName: Yup.string().required("City Name is required"),
  landMark: Yup.string().required("Land Mark is required"),
  projectType: Yup.string().required("Project Type is required"),
});
/* Project Site Schema End */

/* Member Schema Start */
export const memberSiteSchema = Yup.object().shape({
  groupName: Yup.string().required("Group Name is required"),
  cityName: Yup.string().required("City Name is required"),
  landMark: Yup.string().required("Land Mark is required"),
  projectType: Yup.string().required("Project Type is required"),
});
/* Member Schema End */

export const createRoleFormSchema = Yup.object().shape({
  name: Yup.string()
    .required("Username is required")
    //.matches(/^\S*$/, "Name must not contain spaces"),
    .trim("Name cannot include leading and trailing spaces"),
  mobileNo: Yup.string()
    .required("Mobile No is required")
    .min(10, "Please enter a valid 10 digits Phone Number")
    .max(10, "Please enter a valid 10 digits Phone Number")
    .matches(/^\d{10}$/, "Please enter a valid 10 digits Phone Number"),
  developers: Yup.array()
    .required("Developer is required")
    .min(1, "Please select at least one Developer"),
  role: Yup.string()
    .required("User Role is required")
    .trim("User Role cannot include leading and trailing spaces"),
  sites: Yup.array()
    .required("Project Site is required")
    .min(1, "Please select at least one Project Site"),
});

export const editRoleFormSchema = Yup.object().shape({
  role: Yup.string().required("User Role is required"),
  //.min(1, "Please select at least one Developer"),
  //.trim("User Role cannot include leading and trailing spaces"),
  developers: Yup.array()
    .required("Developer is required")
    .min(1, "Please select at least one Developer"),
  /*   sites: Yup.array() // Note: Not required site compulsory 
    .required("Project Site is required")
    .min(1, "Please select at least one Project Site"), */
});
